<template>
	<div class="newpage">
		<span>{{$t('label_272')}}{{total}}{{$t('label_731')}},{{$t('label_734')}}：</span>
			<el-select v-model="newGoPage" :placeholder="$t('input_65')" style="width: 90px;" @change="setPageSize(newGoPage)">
				<el-option v-for="item in options" :key="item.value" :label="item.value" :value="item.value" >
				</el-option>
			</el-select>
			<span style="margin-left: 15px;">{{$t('label_731')}}</span>
			<ul>
        <li :class="{'disabled': current == 1}" @click="setCurrent(1)">{{$t('label_3')}}</li>
        <li :class="{'disabled': current == 1}" @click="setCurrent(current - 1)">{{$t('label_7')}}</li>
        <li v-for="p in grouplist" :class="{'on': current == p.val}" @click="setCurrent(p.val)">{{ p.text }}</li>
        <li :class="{'disabled': current == page}" @click="setCurrent(current + 1)">{{$t('label_11')}}</li>
        <li :class="{'disabled': current == page}" @click="setCurrent(page)">{{$t('label_15')}}</li>
			</ul>
	</div>
</template>
<script>
	export default {
		name: "page",
		props: {
			total: { // 数据总条数
				type: Number,
				default: 0
			},
			display: { // 每页显示条数
				type: Number,
				default: 10
			},
			currentspage: { // 当前页码
				type: Number,
				default: 1
			},
			pagegroup: { // 分页条数
				type: Number,
				default: 5,
				coerce: function(v) {
					v = v > 0 ? v : 5;
					return v % 2 === 1 ? v : v + 1;
				}
			}
		},
		data: function() {
			return {
				newGoPage: this.display,
				gopage: this.currentspage,
				current: this.currentspage,
				options: [{
					value: 50,
				}, {
					value: 100,
				}, {
					value: 150,
				}, {
					value: 200,
				}],
			}
		},
		computed: {
			page: function() { // 总页数
				return Math.ceil(this.total / this.display);
			},
			grouplist: function() { // 获取分页页码
				var len = this.page,
					temp = [],
					list = [],
					count = Math.floor(this.pagegroup / 2),
					center = this.current;
				if (len <= this.pagegroup) {
					while (len--) {
						temp.push({
							text: this.page - len,
							val: this.page - len
						});
					};
					return temp;
				}
				while (len--) {
					temp.push(this.page - len);
				};
				var idx = temp.indexOf(center);
				(idx < count) && (center = center + count - idx);
				(this.current > this.page - count) && (center = this.page - count);
				temp = temp.splice(center - count - 1, this.pagegroup);
				do {
					var t = temp.shift();
					list.push({
						text: t,
						val: t
					});
				} while (temp.length);
				if (this.page > this.pagegroup) {
					(this.current > count + 1) && list.unshift({
						text: '...',
						val: list[0].val - 1
					});
					(this.current < this.page - count) && list.push({
						text: '...',
						val: list[list.length - 1].val + 1
					});
				}
				return list;
			}
		},
		methods: {
			setCurrent: function(idx) {
				if (this.current != idx && idx > 0 && idx < this.page + 1) {
					this.current = idx;
					this.$emit('pageNum', this.current);
					this.$emit('parentMethod', {
						pageNum: idx,
						pageSize: this.display
					});
				}
			},
			setPageSize(pageSize) {
				console.log(pageSize)
				this.current = 1;
				this.$emit('pageNum', this.current);
				this.$emit('parentMethod', {
					pageNum: 1,
					pageSize: pageSize
				});
			}
		}
	};
</script>
<style>
	.newpage {
		display: flex;
		height: 30px;
		justify-content: flex-end;
	}

	.newpage span {
		height: 30px;
		line-height: 30px;
	}

	.newpage ul {
		margin: 0;
		padding: 0;
		margin-left: 20px;
		list-style-type: none;
		display: flex;
	}

	.newpage ul li {
		border: 1px #ddd solid;
		border-left: 0;
		height: 28px;
		line-height: 28px;
		width: 28px;
		color: #000000;
		display: flex;
		align-items: center;
		justify-content: center;
		cursor: pointer;
		-webkit-touch-callout: none;
		/* iOS Safari */
		-webkit-user-select: none;
		/* Chrome/Safari/Opera */
		-khtml-user-select: none;
		/* Konqueror */
		-moz-user-select: none;
		/* Firefox */
		-ms-user-select: none;
		/* Internet Explorer/Edge */
		user-select: none;
		/* Non-prefixed version, currently
    not supported by any browser */
	}

	.newpage ul li.on {
		color: #fff;
		background: #0070c9;
	}

	.newpage ul li:first-child {
		border: 1px #ddd solid;
		width: auto;
		line-height: 26px;
		padding: 0 10px;
	}

	.newpage ul li:last-child {
		width: auto;
		line-height: 26px;
		padding: 0 10px;
	}

	.newpage ul li:nth-child(2) {
		width: auto;
		line-height: 26px;
		padding: 0 10px;
	}

	.newpage ul li:nth-last-child(2) {
		width: auto;
		line-height: 26px;
		padding: 0 10px;
	}

	.newpage button {
		background: #f5f5f5;
		border: 1px #ddd solid;
		height: 30px;
		width: 30px;
		margin-left: 20px;
		flex-wrap: nowrap;
		justify-content: flex-end;
	}

	.newpage input {
		border: 1px #ddd solid;
		width: 80px;
		margin-left: 10px;
		height: 30px;
		flex-wrap: nowrap;
		justify-content: flex-end;
	}
	.newpage .el-input__icon{
		line-height: 30px;
	}
</style>



// WEBPACK FOOTER //
// src/components/common/pageNew2.vue